import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestFormService } from 'src/app/home/services/request-form.service';
import { UtilsNotificationService } from 'src/app/utils/utils-notification.service';
import { FORM_TYPE_KEY } from '../../utils/constants/constats';
import { RequestEmployeeUtilsService } from '../../utils/request-employee-utils.service';


@Component({
  selector: 'app-view-edit-form',
  templateUrl: './view-edit-form.component.html',
  styleUrls: ['./view-edit-form.component.scss'],
})
export class ViewEditFormComponent implements OnInit {
  status_request!: string;
  correction!: boolean;
  json_files: any[] = [];
  dataRequest: any;
  summary_data!: any;
  template_data!: any;
  emptyFiles = false;
  list_files: File[] = [];
  name_employee!: string;
  createdDate!: string;
  monto_propuesto = '';
  cuotas_propuesta = '';
  valor_cuota = '';
  solicitudAprobadaAdmin!: boolean;
  orderedFields: any = {
    informacion_personal: [],
    beneficiarios: [],
    direccion: [],
    informacion_adicional: [],
  };
  numericFields = [
    'Teléfono',
    'Monto',
    'Compromiso_de_pago',
    'Costos_asociados',
    'Número_de_boleta',
  ];
  fileExists = false;
  duplicateFileError = '';
  keyPrestamoCompania = FORM_TYPE_KEY.FRM_PRESTAMO_COMPANIA
  isLoading!: boolean;
  keyFormRequest!: string | undefined;
  formTypeKey = FORM_TYPE_KEY;
  popupModificacionPersonas: boolean = false;
  usuarios: any = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private requestFormService: RequestFormService,
    private utilsService: UtilsNotificationService,
    private employee_utils: RequestEmployeeUtilsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.dataRequest = this.activatedRoute.snapshot.data['resolver_request_details_id'];
    this.data_request();
    if (this.formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR !== this.keyFormRequest) {
      this.convertToArray();
    }

    if (this.formTypeKey.FRM_CAMBIO_PLAN === this.keyFormRequest) {
      this.summary_data.archivos = []
    }

  }

  data_request() {
    this.summary_data = JSON.parse(this.dataRequest.requestdata);
    this.status_request = this.dataRequest.statusRequest;
    this.keyFormRequest = this.summary_data.formulario;

    this.name_employee = this.nombreEmpleado(this.keyFormRequest)
    this.template_data = this.summary_data;
    this.createdDate = this.utilsService.formatDate(
      new Date(this.dataRequest.createdAt),
    );

    if (this.formTypeKey.FRM_SALUD_DENTAL === this.keyFormRequest) {
      this.summary_data.archivos = this.dataRequest.files;
    }
  }
  nombreEmpleado(keyFormulario: string | undefined) {
    switch (keyFormulario) {
      case 'FRM_CAMBIO_PLAN':
        return `${this.summary_data.informacion_personal.Nombres.valor} ${this.summary_data.informacion_personal.Apellido_Paterno.valor}`
      case 'FRM_SALUD_DENTAL':
        return `${this.summary_data.informacion_personal.Nombres.valor} ${this.summary_data.informacion_personal.Apellido_Paterno.valor}`
      case 'SOLICITUD_COLECTIVA_TRABAJADOR':
        return this.summary_data.tabla_datos[0]['Nombre Titular']
      default:
        return `${this.summary_data.informacion_personal.Nombres.valor}
     ${this.summary_data.informacion_personal.Apellidos.valor}`

    }
  }

  getOrderedFields(data: any): any[] {
    return Object.keys(data)
      .map((key) => ({ key, ...data[key] }))
      .sort((a, b) => a.index - b.index);
  }

  convertToArray() {
    this.orderedFields.informacion_personal = this.getOrderedFields(
      this.summary_data.informacion_personal,
    );
    this.orderedFields.beneficiarios = this.getOrderedFields(
      this.summary_data.beneficiarios,
    );
    this.orderedFields.direccion = this.getOrderedFields(
      this.summary_data.direccion,
    );
    this.orderedFields.informacion_adicional = this.getOrderedFields(
      this.summary_data.informacion_adicional,
    );
  }

  isObjectEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  onSubmit() {
    if (this.isLoading) {
      return;
    }

    if (this.filesToCorrect() || this.formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR === this.keyFormRequest) {
      this.addFilesAndProcess();
    } else {
      this.saveAllValues();
    }
    this.isLoading = false;
  }

  addFilesAndProcess() {
    this.verify_count_files();
    if (!this.emptyFiles) {
      this.isLoading = true;
      let hasDuplicate = false;
      if (!this.summary_data.hasOwnProperty('archivos')) {
        this.summary_data.archivos = [];
      }
      for (const f of this.json_files) {
        this.fileExists = this.summary_data.archivos.some(
          (file: any) => file.valor === f.valor,
        );
        if (this.fileExists) {
          this.duplicateFileError = `El archivo ${f.valor} ya ha sido subido.`;
          hasDuplicate = true;
          break;
        } else {
          this.summary_data.archivos.push(f);
        }
      }

      if (!hasDuplicate) {
        this.send_files_s3();
        this.saveAllValues();
      }
    }
  }

  async saveAllValues() {
    this.isLoading = true;
    this.summary_data = JSON.parse(JSON.stringify(this.template_data));
    this.quitFilesinTrue();
    this.resetCorregir();
    await this.savedEdit();
    this.router.navigate(['/successful-request', { success: true }]);
  }

  resetCorregir() {
    for (const section in this.summary_data) {
      if (section !== 'archivos') {
        if (this.summary_data.hasOwnProperty(section)) {
          const sectionData = this.summary_data[section];
          this.sectionIsObject(sectionData);
        }
      }
    }
  }

  sectionIsObject(sectionData: any) {
    if (typeof sectionData === 'object' && sectionData !== null) {
      for (const key in sectionData) {
        this.fieldstoCorrect(key, sectionData);
      }
    }
  }

  fieldstoCorrect(key: string, sectionData: any) {
    if (
      sectionData.hasOwnProperty(key) &&
      sectionData[key].hasOwnProperty('corregir')
    ) {
      sectionData[key].corregir = false;
    }
  }

  save_file(event: any) {
    this.json_files = [];
    this.json_files = event.nombres;
    this.list_files = event.listfiles;
    this.verify_count_files();
  }

  verify_count_files() {
    if (this.json_files.length !== 0) {
      this.emptyFiles = false;
    } else {
      this.emptyFiles = true;
    }
  }

  send_files_s3() {
    for (const i of this.list_files) {
      this.requestFormService.put_file_s3(i);

    }
  }

  filesToCorrect() {
    for (const x of this.summary_data.archivos) {
      if (x.corregir === true) {
        return true;
      }
    }
    return false;
  }

  quitFilesinTrue() {
    this.summary_data.archivos = this.summary_data.archivos.filter(
      (x: any) => !x.corregir,
    );
  }

  getIconStatus(): string {
    switch (this.status_request) {
      case 'Enviada':
        return '/assets/icon-summary/review.svg';
      case 'Aprobada':
        return '/assets/icon-summary/approved.svg';
      case 'Rechazada':
        return '/assets/icon-summary/reject.svg';
      case 'Con error':
        return '/assets/icon-summary/with_error.svg';
      case 'Anulada':
        return '/assets/icon-summary/anulada.svg';
      default:
        return '/assets/icono-status/review.svg';
    }
  }

  correctFields() {
    this.correction = true;
  }



  async savedEdit() {
    try {
      const request = {
        id: this.dataRequest.idrequest,
        estado_solicitud_id: 1,
        formulario: JSON.stringify(this.summary_data),
        beneficio_id: this.dataRequest.typedata.id,
      };
      const response = await this.requestFormService.putRequestForms(request);
      if (response.statusCode) {
        this.router.navigate(['/successful-request', { success: true }]);
        this.isLoading = false;
      }
    } catch (error: any) {
      console.error('Error:', error);
      this.router.navigate(['/successful-request', { success: false }]);
      this.isLoading = false;
    }
  }

  cancelEdit() {
    this.correction = false;
  }

  getFieldType(key: string): string {
    if (key.includes('Teléfono')) {
      return 'tel';
    } else if (key.includes('Fecha')) {
      return 'date';
    } else {
      return 'text';
    }
  }

  onKeyPress(event: KeyboardEvent, key: string) {
    if (this.numericFields.some((field) => key.includes(field))) {
      this.employee_utils.soloNumerosMontos(event)
    }
  }

  valueField(value: any) {
    if(Array.isArray(value)) {
      if(this.dataRequest.typedata.id === 24) {
        return value.map((element: any) => element.nombre).join(', ');
      }
    }
    return value;
  }

  modificar(data: any) {
    this.usuarios = data;
    this.popupModificacionPersonas = true;
  }

  grabar() {
    this.template_data.informacion_adicional["Usuarios"]["valor"] = this.usuarios;
    this.popupModificacionPersonas = false;
  }

  cerrarModal() {
    this.popupModificacionPersonas = false;
  }
}
